import styled from '@emotion/styled';

export const Container = styled.button`
  width: 100%;
  height: 40px;
  background: rgba(255, 255, 255, 0.12549);
  font-size: 14px;
  color: white;
  border: 1px solid #ffffff;
  border-radius: 4px;
  cursor: pointer;
`;
